module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Breakfast"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e144"
    }
  }), _vm._v("Breakfast")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "nodivide"
  }, [_c('a', {
    attrs: {
      "id": "d0e147"
    }
  }), _vm._v("Breakfast Memories ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("Sausage ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("5 to 6 potatoes, cubed ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 small onion, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 c green pepper, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 to 7 eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Milk (optional) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 c American or cheddar cheese ")])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e164"
    }
  }), _vm._v("Gravy: ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 Tbsp flour ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salt and pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 glass milk ")])]), _vm._v(" "), _c('p', [_vm._v("Cook sausage in a skillet. Remove sausage and add potatoes to skillet with grease\n                from sausage (add shortening if needed to keep potatoes from sticking). Add onion\n                and green pepper. Cook until potatoes are tender. Add eggs and crumbled sausage. Can\n                add a little milk to eggs to make them fluffy. Add cheese. Cook until eggs are done. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Gravy:")])]), _vm._v(" Mix flour with salt and pepper in\n                just enough grease to coat the bottom of the skillet. Brown to desired doneness and\n                add about a glass of milk. If not enough, add water until your skillet is about 3/4\n                full. Stir constantly until gravy starts to thicken. Remove from heat and stir until\n                desired consistency is obtained. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Note:")])]), _vm._v(" I add garlic to the potatoes as they\n                are cooking — just enough to taste, and this works in two ways: adds a good flavor\n                and helps keep the insects away. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Sharon Waid, Region 8, Ozark-St. Francis National Forests, Arkansas")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar",
    attrs: {
      "title": "Hint"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Hint")])]), _vm._v(" "), _c('p', [_vm._v("Butter will keep indefinitely by submerging in a strong salt solution, preferably\n                    in a sealed fruit jar. Keep in a cool place.")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e191"
    }
  }), _vm._v("Dutch Oven Breakfast ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 Tbsp olive oil ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 cloves garlic, crushed ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 Polish kielbasa sausage ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 onions, sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 potatoes, boiled and chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 Tbsp diced green chilies ")])]), _vm._v(" "), _c('p', [_vm._v("In a 10-inch Dutch oven, heat olive oil, add garlic. Stir twice and add sausage.\n                Brown on both sides. Add onions, cook until tender. Add potatoes and chilies and\n                simmer 10 minutes. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Hugh and Pam Thompson, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/FlyerCover.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Camp stove, Wasatch National Forest, Utah, circa 1935.")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e219"
    }
  }), _vm._v("Cowboy Breakfast ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 roll sausage; bacon and ham can be added ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 c chopped onion ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 dozen eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 c milk or 2 Tbsp sour cream ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salt and pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 to 6 slices Velveeta brand cheese ")])]), _vm._v(" "), _c('p', [_vm._v("Cook sausage, bacon, ham, and onion. Beat eggs and milk or sour cream. Pour mixture\n                over meats and onion. Cook in large skillet over open fire. Add salt and pepper to\n                taste. Top with cheese. Optional — chopped hashbrown potatoes, mushrooms, and bell\n                peppers can be added. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Judy Boren, Region 8, Land Between the Lakes National Recreation Area,\n                        Kentucky")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/307714WasatchNF.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Scouts cooking supper at Scout Lake Camp, Wasatch National Forest, Utah,\n                        August 1935. (Photo by K. D. Swan)")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e247"
    }
  }), _vm._v("Hungry Man Breakfast ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 lb bacon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 medium onions, diced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 cans mushrooms, drained ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 green pepper, diced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cloves garlic, minced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("10 to 12 medium potatoes, sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salt and pepper to taste ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("12 eggs, beaten ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 c grated cheddar cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salsa or barbecue sauce (optional) ")])]), _vm._v(" "), _c('p', [_vm._v("Heat 12-inch Dutch oven until hot, using 18-20 briquettes on the bottom. Cut bacon\n                into 1-inch slices and fry till brown. Add onions, mushrooms, green pepper, garlic\n                and sauté until onions are translucent. Add potatoes and season with salt and\n                pepper. Cover and bake using 8 briquettes on the bottom and 14-16 on top for 30\n                minutes. Season eggs with salt and pepper then pour over top of potatoes. Cover and\n                bake another 20 minutes. Stir every 5 minutes. When eggs are done, cover top with\n                cheese and replace lid. Let stand until cheese is melted. Serves 10-12. Can use\n                salsa or barbecue sauce to top. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Bob VanGieson, Region 1, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar",
    attrs: {
      "title": "Fact"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Fact")])]), _vm._v(" "), _c('p', [_vm._v("From the Intermountain Region "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Old Timers\n                        News")])]), _vm._v(" of October 1967, Raymond D. Garver told of helping survey\n                    and mark some 400 miles of forest boundary with cut cedar posts and tin boundary\n                    signs on the Toiyabe National Forest in Nevada. The year was 1913 and equipment\n                    was a sheep wagon and buckboard, a team of mules and a team of horses. The three\n                    Rangers were Kivett as cook, camp mover, and general helper; Cahill as stadia\n                    man; and Woolley as post getter and setter. Garver wrote, “Some days we could\n                    run 10 miles of line; other days half as much or less. Kivett said we worked too\n                    hard and made him get up and cook breakfast too early. Most of the time good\n                    nature prevailed.” ")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e283"
    }
  }), _vm._v("Camper’s Omelette ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 lb bacon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 to 3 medium potatoes, unpeeled and chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 medium onion, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 bell pepper, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 eggs (whisked fluffy) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 firm tomato (optional), sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("8 oz sharp cheddar cheese, grated or chopped fine ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Bacon, cooked and crumbled for topping ")])]), _vm._v(" "), _c('p', [_vm._v("Fry bacon till crisp in cast-iron skillet. Remove bacon and fry chopped potatoes in\n                grease until tender; throw in onion and pepper. When onion appears cooked, reduce\n                heat to pan by moving to side of firepit or turning down the campstove burner. Pour\n                in eggs and cover for about 3-5 minutes, stirring occasionally to avoid scorching.\n                Place tomato slices, cheese, and crumbled bacon on top. Cover again for a few\n                minutes until cheese melts and the tomatoes are smiling. ")]), _vm._v(" "), _c('p', [_vm._v("Remove from fire, slice in wedges and serve. (I use a little hot sauce to kick it up\n                a notch.) Serves 4. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Jim Hasbrouck, Region 8, Regional Office, Georgia")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/Gifford_Pinchot2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Gifford Pinchot camping in the Adirondacks, New York, USDA Forest Service,\n                        Grey Towers National Historic Landmark.")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e317"
    }
  }), _vm._v("Sportsman’s Breakfast ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 to 8 slices bacon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("8 to 10 medium unpeeled potatoes, washed and sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 can green chilies, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 medium red onion, diced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Cheddar cheese ")])]), _vm._v(" "), _c('p', [_vm._v("Cut bacon into 1-inch pieces and place in cast-iron skillet with moderate fire. When\n                bacon is about 3/4 cooked, place potatoes and chilies in skillet and cover with a\n                lid. When potatoes are 3/4 cooked, add onions. Cook until onions are done. Add eggs\n                and cook till eggs are done. Place slices of cheddar cheese over top before meal is\n                served. Feeds 4 adults. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Paul Shields, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar",
    attrs: {
      "title": "Hint"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Hint")])]), _vm._v(" "), _c('p', [_vm._v("To impart a barbecue flavor to broiled meats, sprinkle with instant coffee while\n                    cooking.")])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/399932AbsarokaNFForC15ED.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Forest Service reconnaissance party in camp at Lake Abundance. Ranger Carl S.\n                        Walker standing, Dave Maclay seated in back of stovepipe, Supervisor Derrick\n                        without hat, Percy Melis back view second to left, Absaroka National Forest,\n                        Montana, July 1938. (Photo by K. D. Swan)")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e350"
    }
  }), _vm._v("One-Eyed Buffaloes ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("10 eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 c milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tsp nutmeg ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tsp cinnamon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tsp vanilla ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 Tbsp oil ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 loaf bread ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 doz or more eggs ")])]), _vm._v(" "), _c('p', [_vm._v("Mix eggs, milk, nutmeg, cinnamon, and vanilla and beat well. Heat oil on griddle over\n                fire. Dip each slice of bread into egg mixture and put on griddle. Cut out about a\n                3-inch circle in the bread. Break an additional egg into center of each piece of\n                bread on griddle and fry. When bottom of toast is brown, flip over and brown top\n                side of toast and egg. Serve one-eyed buffaloes hot with syrup, jam, or honey. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Don Duff, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/Boy_Cooking.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Mirror Lake, Wasatch National Forest, Utah, 1963.")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e382"
    }
  }), _vm._v("Green River Chili Con Queso\n                Omelette ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 dozen eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 (7-oz) cans whole green chilies ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 lb cheddar cheese, sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 (4-oz) cans mushrooms (or 1/2 lb diced) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 medium onion, diced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 tsp cayenne pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 c milk ")])]), _vm._v(" "), _c('p', [_vm._v("Combine, mix, and beat all ingredients into one mess in a bowl, pan, or whatever you\n                have. Heat griddle over fire coals; spread mixture on griddle and divide into 4\n                servings. Fold over and continue cooking until done or slightly browned. Serve with\n                chili salsa. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Don Duff, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/People_picnicking_2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Picnicking at Vermillion Castle Campground, Dixie National Forest, Utah. Log\n                        tables made by ERA crews, 1937. (Photo by B. Betenson)")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e412"
    }
  }), _vm._v("Hunting Camp Scrambled Eggs ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tsp butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Handful of diced ham, salami, summer sausage, or 5 to 6 slices\n                    bacon (cooked and crumbled) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 can (small) green chilies, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tomato, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 medium red onion, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3-4 green onions, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3-4 fresh mushrooms, sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 c alfalfa sprouts ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 to 2 fresh jalapeno peppers, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 eggs, beaten with 1/4 c milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Black pepper, coarse ground ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Seasoned salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 c cheddar cheese, diced ")])]), _vm._v(" "), _c('p', [_vm._v("Place teaspoon of butter in frying pan and heat at medium temperature. Place all\n                ingredients except eggs, cheese, and seasonings in pan and cook until onions and\n                tomato are nearly done. Add eggs, stirring occasionally, and cook until almost done.\n                Add seasonings and cheese. Remove from heat as soon as cheese begins to melt and\n                eggs are done. Feeds 4 adults. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Paul Shields, Region 4, retiree ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/Women_Cooking.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Girls trying to avoid smoke from grill made from 55-gallon drum with grate,\n                        Cache National Forest, Utah, circa 1950.")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar",
    attrs: {
      "title": "Fact"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Fact")])]), _vm._v(" "), _c('p', [_vm._v("Following is the story of how a chance visit to a church in Cody, Wyoming changed\n                    the entire life of a young man in 1904: ")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('blockquote', [_c('p', [_vm._v("“I was seated beside a sturdy, pleasant young fellow about my own age. We\n                            exchanged the usual few words as strangers might. He introduced himself\n                            as Clarence N. Woods. I replied that my name was Clarence also, but\n                            Clarence B. Swim. This, of course, was before the services had gotten\n                            underway. Woods asked me if I was employed. I told him that I did not\n                            have steady work. He told me that he was a ranger on the Shoshone Forest\n                            Reserve, and for me to call at the Supervisor’s office the following\n                            morning and that he might be able to arrange for me to start work. I\n                            called at the office; Woods was the only person present. After the usual\n                            questions of qualifications, health, etc., he told me that with approval\n                            of the Supervisor he felt sure that he could start me in on Forest\n                            Service work as Forest guard at $60 per month, pending final approval\n                            and appointment from the Washington Office....My temporary appointment\n                            took place early May of 1904. I was given a lineup of the equipment I\n                            would need to start out with — a couple of horses, a riding and pack\n                            saddle, bedding, a tarp or tent, an axe and shovel, cooking outfit, a\n                            gun and grub for at least a couple of weeks. My bank account was already\n                            low, but I made the best of it and started out on this new adventure. I\n                            bought a little black nag, with black eyes, for a saddle horse, for $50.\n                            I bought a glass-eyed Indian pony with ring bones for a pack horse. I\n                            bought a Collins and Morrison saddle for $56, and pack saddle equipment.\n                            Next was bedding. For a greenhorn I did pretty well. I bought a 25-35\n                            Winchester rifle and a 38 Colt that one couldn’t hit the broad side of a\n                            barn with. I later traded this worthless Colt in on a Luger pistol, an\n                            excellent, accurate gun. Next on the list was grub. I bought bacon, ham,\n                            flour, baking powder, beans, canned fruit, dried prunes and a box of\n                            loaf sugar. Woods spent the evening with me giving final instructions\n                            and teaching me the art of packing and throwing the diamond hitch.” ")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Early Days in the Forest Service,")])]), _vm._v(" Volume\n                    I, Northern Region")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e466"
    }
  }), _vm._v("Hunter’s Special Sausage\n                Breakfast Dutch Oven Feast ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("12 to 15 slices bread, cubed ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cube butter, melted ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 lb grated cheddar cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("18 eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3/4 c milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tsp dry mustard ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salt and pepper to taste ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 lb cooked sausage ")])]), _vm._v(" "), _c('p', [_vm._v("Add bread cubes to a well-greased 12-inch Dutch oven. Drizzle butter over bread then\n                sprinkle with the grated cheese. Whisk together eggs, milk, and mustard. Add salt\n                and pepper to your liking. Pour eggs over bread and cheese. Sprinkle the cooked\n                sausage on the top. Cover and bake using 6 to 8 briquettes on the bottom and 12-14\n                briquettes for the top for 30-45 minutes, or until eggs are set. Serves 8 to 10\n                people. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("John Hoel, Region 4, Regional Office, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/Ranger_Picnickers.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Ranger Jack McNutt visits with picnickers on Mountain Mahogany Grove, Nevada\n                        National Forest, June, 1940. (Photo by P. S. Bieler)")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e498"
    }
  }), _vm._v("Huevos Tixieros ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 pkgs pre-cooked breakfast sausages ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Garlic salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 dozen eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 can chopped green chilies ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 bell pepper, chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 c chopped onion ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/3 c milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 Waverly Wafers brand crackers ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salsa ")])]), _vm._v(" "), _c('p', [_vm._v("Cut sausages into 1/4-inch cartwheels, brown in large cast-iron skillet over medium\n                fire, drain excess grease, sprinkle with garlic salt. In small bowl mix eggs, green\n                chilies, bell pepper, onion, milk, and crushed crackers. Pour egg mixture in skillet\n                and add pepper; let set up and then stir minimum amount until done. Serve with\n                salsa, biscuits and honey. Serves about 4 (hungry) or 6 (not very). ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Stan Tixier, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/27900aPikeNF.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Automobile campers touring through the Pike National Forest, Colorado, July\n                        1916. (Photo by W. J. Hutchinson)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar",
    attrs: {
      "title": "Fact"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Fact")])]), _vm._v(" "), _c('p', [_vm._v("William W. Morris, who worked on the Coeur d’Alene National Forest in Idaho from\n                    1909-1914, wrote about his experiences with rough reconnaissance work. He\n                    wrote,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('blockquote', [_c('p', [_vm._v("“Most of the summer we spent in a little tent or sometimes in the open.\n                            The country was new and almost unexplored. Occasionally we would come to\n                            an old settler’s cabin, and sleeping in one of these one night, I had my\n                            first experience with pack rats. The pack rat is a large mountain rat,\n                            so named because it has the habit of packing off to its nest almost\n                            everything that it sees. They seem to be particularly partial to all\n                            bright shiny objects, such as spoons, silver dollars, etc. The woodsmen\n                            regard them with more or less superstition, as they have a peculiar\n                            method of tapping in the nighttime, when one is trying to sleep, much in\n                            the manner of the Morse telegraph code. This they do with their back\n                            feet. I remember one old cabin where we slept one night, a carpet had\n                            been hung out at the head of a bed built of logs. When we laid down in\n                            the bed our heads touched against this carpet. I remember waking up\n                            several times in the night, feeling a pack rat rubbing against my head,\n                            as it ran back and forth on the other side of the carpet. There had been\n                            some volunteer potatoes come up near this cabin, and that night the pack\n                            rats had been working diligently, and had cut all these potato stalks\n                            down and placed them all in front of our cabin door where we saw them\n                            the first thing in the morning on going to make our ablutions in the\n                            cold mountain stream flowing near. My friend the cruiser remarked that\n                            he thought it was a “whitecap” warning to get out, which we did as our\n                            work at this place was completed.” ")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Early Days in the Forest Service,")])]), _vm._v(" Volume\n                    1, Northern Region ")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e546"
    }
  }), _vm._v("River Runnin’ Coffee ")]), _vm._v(" "), _c('p', [_vm._v("Use coffee pot or empty 1-pound coffee tin. Fill tin with water to within 1 inch of\n                top of tin. Holds 12 cups of water. Put in 1 tablespoon of coffee for each cup. Set\n                tin on red-hot bed of coals and forget about it until it boils. Take pot off coals\n                and add 1/2 cup cold water to settle grounds, or toss in two eggshells to do the\n                same thing. ")]), _vm._v(" "), _c('p', [_vm._v("To clean inside of tin, wipe dry with paper towels or cloth. Use no soap! To reduce\n                soot on outside of tin, coat outside of tin with soap before putting it on coals.\n                Soot will then wash off, even in cold water. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Don Duff, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/Cornelia_Gifford.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Cornelia and Gifford Pinchot over campfire, USDA Forest Service, Grey Towers\n                        National Historic Landmark.")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e563"
    }
  }), _vm._v("Stuffed French Toast ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("Texas toast ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Cream cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Cinnamon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Syrup ")])]), _vm._v(" "), _c('p', [_vm._v("Chunk bread and cream cheese in a bowl. Mix in eggs, milk, salt, cinnamon, and syrup\n                and let sit overnight in the refrigerator. Place in a Dutch oven and bake until\n                done. Serve with powdered sugar and/or syrup. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Dan Krutina, Region 4, retiree")])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/Cornelia_Pinchot.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Cornelia Pinchot cooking over campfire, USDA Forest Service, Grey Towers\n                        National Historic Landmark.")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e593"
    }
  }), _vm._v("Quick Scones ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 c vegetable oil for frying ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 to 6 English muffins, cut in half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 to 3 c prepared pancake batter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Toppings of your choice ")])]), _vm._v(" "), _c('p', [_vm._v("Heat a 12-inch Dutch oven over 12-15 hot coals. Heat oil until a drop of pancake\n                batter dropped into the skillet sizzles. With a fork, dip muffins into the pancake\n                batter and carefully add to the hot oil. Cook on both sides until golden brown.\n                Remove and drain on paper towels. Serve hot with topping, as desired. Serves 4. ")]), _vm._v(" "), _c('p', [_vm._v("Serve plain or topped with sugar, powdered sugar, brown sugar, cinnamon sugar, honey,\n                jam, jelly, or syrup. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Dian Thomas, from")])]), _vm._v(" Recipes for Roughing It\n                Easy")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "This is an image of camping."
    }
  }, [_c('img', {
    attrs: {
      "alt": "This is an image of camping.",
      "src": "images/MonongahelaNF.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Family picnicking at Smokehole Recreation Area, Region 9, Monongahela\n                        National Forest, West Virginia, July 1966.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f008b1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch03.vue
// module id = 72
// module chunks = 0